import type { LicenseStatus } from "@/lib/types";

/**
 * Returns the status Admin Web should display without changing the persisted
 * License lifecycle. A non-active lifecycle always takes precedence over
 * validity expiry.
 */
export function licenseDisplayStatus(
  status: LicenseStatus | string,
  validUntil: string | null | undefined,
  now = Date.now(),
) {
  if (status !== "active" || !validUntil) return status;

  const expiresAt = Date.parse(validUntil);
  return Number.isFinite(expiresAt) && now >= expiresAt ? "expired" : status;
}
